import React, { useEffect, useState } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

import _without from "lodash/without";
import { Checkbox } from "@mui/material";
import { CheckboxBlankIcon, CheckboxBlankOutlineIcon, CheckBoxOutlineIcon } from "@icons/material";

const useStyles = makeStyles((theme) =>
    createStyles({
        redBackground: {
            padding: 10
        },
        whiteBackground: {
            backgroundColor: "#FFF"
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            maxWidth: 300,
        },
        chips: {
            display: "flex",
            flexWrap: "wrap"
        },
        chip: {
            margin: 2,
            backgroundColor: "lightgray",
        },
        noLabel: {
            marginTop: theme.spacing(3)
        }
    })
);

const MultipleUserSelect = ({ user, setSelectedUsers, isError }) => {
    const classes = useStyles();
    const [users, setUsers] = useState([])

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250
            }
        }
    };

    const handleChange = (_, selectedUsersParam) => {
        setSelectedUsers(selectedUsersParam);
    };

    useEffect(() => {
        const endpoint = '/algo-trading/api/admin/users';
        fetch(endpoint, {
            headers: new Headers({
                'Authorization': user.credential
            }),
        }
        ).then(r => {
            if (r.status >= 400) {
                return
            }
            r.text()
                .then(value => {
                    setUsers(JSON.parse(value))
                })
        }
        ).catch(error => {
            console.log(error);
            // history.push('/')
        });
    }, [user]);


    return (
        <Stack spacing={3}>
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                options={users}
                getOptionLabel={(option) => `${option?.id} - ${option?.name}`}
                getOptionKey={(option => option?.id)}
                onChange={handleChange}
                disableCloseOnSelect
                renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                        <li key={key} {...optionProps}>
                            <Checkbox
                                icon={<CheckboxBlankOutlineIcon fontSize="small" />}
                                checkedIcon={<CheckBoxOutlineIcon fontSize="small" />}
                                style={{ marginRight: 8 }}
                                checked={selected}
                            />
                            {option?.id} - {option?.name}
                        </li>
                    );
                }}
                renderInput={(params) => (
                    <TextField {...params} label="Select users" placeholder="Users" error={isError} helperText={isError ? 'Please select a user' : ''} />
                )}
            />

        </Stack>
    );
};

export default MultipleUserSelect;
